import React from 'react';

export default ({ label, children }) => (
    <div className='row'>
        <div className='col-7'>{label}</div>
        <div className='col-5 text-right'>{children}</div>
    </div>
);